module.exports = __webpack_public_path__ + "static/schmink3-9e5e129fd9a81ec73269221cee12310d.jpg";